import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["deselect", "select", "menuToggle"];

  select(event) {
    if (event.currentTarget.control.checked) {
      event.preventDefault();

      this.deselectTarget.checked = true;
    }
  }

  deselect(event) {
    if (!this.element.contains(event.target)) {
      this.deselectTarget.checked = true;
      this.menuToggleTarget.checked = false;
    }
  }
}
